<template>

    <div class="app-container" v-if="canList">
        <div class="filter-container">
            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="用户名称"
                      v-model="listQuery.entity.comment.name">
            </el-input>
            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="用户编号"
                      v-model="listQuery.entity.comment.userCode">
            </el-input>
   <!--         <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="订单item_id"
                      v-model="listQuery.entity.comment.itemId">
            </el-input>-->
            <el-select @change='handleFilter' clearable class="filter-item input" style="width: 130px"
                       v-model="listQuery.entity.comment.goodsId"
                       placeholder="产品名">
                <el-option v-for="(item) in  goodsList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
            </el-select>
    <!--        <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="评论内容"
                      v-model="listQuery.entity.comment.content">
            </el-input>-->
            <el-select @change='handleFilter' clearable class="filter-item input" style="width: 130px"
                       v-model="listQuery.entity.comment.status"
                       placeholder="是否通过">
                <el-option v-for="(item,index) in  statusOptions" :key="item" :label="item" :value="index">
                </el-option>
            </el-select>
            <el-date-picker
                    @change='handleFilter'
                    value-format="yyyy-MM-dd HH:mm:ss"
                    class="filter-item input"
                    v-model="listQuery.entity.comment.times"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="评论时间开始日期"
                    end-placeholder="评论时间结束日期">
            </el-date-picker>

            <div style="display: inline-block">

                <el-button style="margin-left: 10px;" class="filter-item" type="primary" v-waves icon="el-icon-search"
                           @click="handleFilter">查找
                </el-button>
                <el-button class="filter-item" style="margin-left: 10px;" @click="handleCreate" type="primary"
                           v-if="canSave" icon="el-icon-edit">添加
                </el-button>
            </div>
        </div>

        <el-table :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;">
            <yf-table-column align="center" label="ID">
                <template slot-scope="scope">
                    <span>{{scope.row.comment.id}}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="用户名称">
                <template slot-scope="scope">
                    <span v-if="scope.row.comment">{{scope.row.comment.name}}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="用户编号">
                <template slot-scope="scope">
                    <span v-if="scope.row.comment">{{scope.row.comment.userCode}}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="产品名">
                <template slot-scope="scope">
                    <span v-if="scope.row.comment">{{scope.row.comment.goodsName}}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="评论内容">
                <template slot-scope="scope">
                    <span v-if="scope.row.comment">{{scope.row.comment.content}}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="是否通过">
                <template slot-scope="scope">
                                                <span v-if="scope.row.comment">

                         <el-tag :type="tagTypes[scope.row.comment.status]" v-if="scope.row.comment.status!=null">     {{statusOptions[scope.row.comment.status]}}</el-tag>

                        </span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="评论时间" width="160">
                <template slot-scope="scope">
                    <span v-if="scope.row.comment">{{parseTime(scope.row.comment.time)}}</span>
                </template>
            </yf-table-column>

            <yf-table-column align="center" label="操作" width="230" class-name="small-padding fixed-width">
                <template  slot-scope="scope">
                    <el-popconfirm v-if="scope.row.comment.status == 1"
                            placement="top"
                            confirmButtonText='通过'
                            cancelButtonText='未通过'
                            icon="el-icon-info"
                            iconColor="red"
                            title="正在进行审核操作功能？"
                            @onConfirm="onConfirm(scope.row.comment)"
                            @onCancel="onCancel(scope.row.comment)"
                    >
                        <el-button style="margin-right: 5px" type="success" size="mini" slot="reference">审核</el-button>
                    </el-popconfirm>
                    <el-button type="primary" v-if="canUpdate" size="mini" @click="handleUpdate(scope)">编辑</el-button>
                    <el-button v-if="canSave" size="mini" type="danger"
                               @click="handleDelete(scope)">删除
                    </el-button>
                </template>
            </yf-table-column>

        </el-table>

        <div class="pagination-container" style="margin-top: 20px">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                           layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

        <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
            <el-form :rules="rules" ref="dataForm" :model="temp" label-position="left" label-width="120px"
                     style='width: 450px; margin-left:50px;'>
                <el-form-item label="用户名称" prop="comment.name">
                    <el-input  v-model="temp.comment.name"></el-input>
                </el-form-item>
                <el-form-item label="用户编号" prop="comment.userId">
                    <el-input  v-model="temp.comment.userCode"></el-input>
                </el-form-item>
               <!-- <el-form-item label="订单item_id" prop="comment.itemId">
                    <el-input  v-model="temp.comment.itemId"></el-input>
                </el-form-item>-->
                <el-form-item label="产品名" prop="comment.goodsId">
                    <el-select   class="filter-item" v-model="temp.comment.goodsId" placeholder="产品名">
                        <el-option v-for="(item) in  goodsList" :key="item.id" :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="评论内容" prop="comment.content">
                    <el-input  v-model="temp.comment.content"></el-input>
                </el-form-item>
                <el-form-item label="是否通过" prop="comment.status">
                    <el-select class="filter-item" v-model="temp.comment.status" placeholder="是否通过">
                        <el-option v-for="(item,index) in  statusOptions" :key="item" :label="item"
                                   :value="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="评论时间" prop="comment.time">
                    <el-date-picker  v-model="temp.comment.time" type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss" placeholder="评论时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="头像" prop="comment.avatar">
                    <div class="block"><el-avatar :size="50" :src="temp.comment.avatar"></el-avatar></div>
                    <!--<el-upload
                            ref="avatarUpload"
                            action="https://upload.qiniup.com"
                            :auto-upload="true"
                            list-type="picture-card"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="handleUpload"
                            :file-list="avatarList"
                            :on-success="(response, file, fileList)=>handleImgUploadSuccess(avatarList,file)"
                            :data="qData"
                            :on-remove="(file, fileList)=>handleImgRemove(avatarList,file)">
                        <i class="el-icon-plus"></i>
                    </el-upload>-->
                </el-form-item>
                <el-form-item label="评论内容图片" prop="comment.img">
                    <el-upload
                            ref="imgUpload"
                            action="https://upload.qiniup.com"
                            :auto-upload="true"
                            list-type="picture-card"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="handleUpload"
                            :file-list="imgList"
                            :on-success="(response, file, fileList)=>handleImgUploadSuccess(imgList,file)"
                            :data="qData"
                            :on-remove="(file, fileList)=>handleImgRemove(imgList,file)">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>

                <el-dialog :visible.sync="dialogVisible" append-to-body>
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogForm">取消</el-button>
                <el-button v-if="dialogStatus=='create'" type="primary" @click="createData">确认</el-button>
                <el-button v-else type="primary" @click="updateData">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<style type="stylus">
    .filter-container {
        /*padding-bottom: 20px;*/
    }

    .filter-item {
        margin-bottom: 10px;
    }

    .filter-item.input {
        /*line-height: 60px*/
        margin-right: 10px;
    }
</style>

<script>
    import {list, options, info, save, update, remove} from '@/api/comment'
    import waves from '@/directive/waves' // 水波纹指令
    import {parseTime} from '@/utils'

    import {getToken, domain} from '@/api/qiniu'
    import {listToStrs, strsToList} from '@/utils/imgUtil'

    import {mapGetters} from 'vuex'
    import {hasAuth} from '@/utils/auth'

    export default {
        name: 'test',
        directives: {
            waves
        },
        data() {
            return {
                tableKey: 0,
                list: null,
                total: null,
                listLoading: true,
                time: null
                ,
                listQuery: {
                    page: 1,
                    limit: 20,
                    order: 'comment.id desc',
                    entity: {
                        comment:
                            {
                                id: null,
                                avatar: null,
                                name: null,
                                userId: null,
                                itemId: null,
                                goodsId: null,
                                content: null,
                                img: null,
                                time: null,
                                userCode: null,
                                status: null
                            }
                    }
                },
                statusOptions: [],
                goodsList:[],
                tagTypes: ['info', '', 'warning', 'danger', 'warning'],
                temp: {

                    comment:
                        {
                            id: null,
                            avatar: null,
                            name: null,
                            userId: null,
                            itemId: null,
                            goodsId: null,
                            content: null,
                            img: null,
                            time: null,
                            userCode: null,
                            status: null
                        }


                }
                ,
                dialogFormVisible: false,
                dialogStatus: '',
                textMap: {
                    update: '修改',
                    create: '新增'
                }
                ,
                // 存在图片
                dialogImageUrl: '',
                dialogVisible: false,
                avatarList: [],
                imgList: [],
                rules:
                    {
                        'comment.avatar': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'comment.name': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'comment.userId': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'comment.itemId': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'comment.goodsId': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'comment.content': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'comment.img': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'comment.time': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'comment.status': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'blur'
                            }
                        ]
                    }
                ,
                downloadLoading: false,
                qData:
                    {
                        token: '',
                        key: ''
                    }
            }
        },
        created() {
            this.getList()
            this.getOptions()
        },
        computed: {
            ...mapGetters([
                'perms'
            ]),
            canSave() {
                return hasAuth(this.perms, 'comment:save')
            },
            canDelete() {
                return hasAuth(this.perms, 'comment:delete')
            },
            canUpdate() {
                return hasAuth(this.perms, 'comment:update')
            },
            canList() {
                return hasAuth(this.perms, 'comment:list')
            }
        },
        methods: {
            onConfirm(value){
                this.temp.comment = value
                this.temp.comment.status= 2
                update(this.temp).then(() => {
                    // this.list.splice(this.index, 1, this.temp)
                    this.getList()
                    this.closeDialogForm()
                    this.$notify({
                        title: '成功',
                        message: '审核成功',
                        type: 'success',
                        duration: 2000
                    })
                })
            },
            onCancel(value){
                this.temp.comment = value
                this.temp.comment.status= 0
                update(this.temp).then(() => {
                    // this.list.splice(this.index, 1, this.temp)
                    this.getList()
                    this.closeDialogForm()
                    this.$notify({
                        title: '成功',
                        message: '审核成功',
                        type: 'success',
                        duration: 2000
                    })
                })
            },
            parseTime(time) {
                if (!time) return ''
                return parseTime(time, '{y}-{m}-{d} {h}:{i}:{s}')
            },
            getList() {
                this.listLoading = true
                list(this.listQuery).then(response => {
                    this.list = response.data.list
                    this.total = response.data.total
                    this.goodsList = response.extra.goods
                    this.listLoading = false
                })
            },
            getOptions() {
                options().then(res => {
                    this.statusOptions = res.data.statusOptions
                })
            },
            handleFilter() {
                this.listQuery.page = 1
                this.getList()
            },
            handleSizeChange(val) {
                this.listQuery.limit = val
                this.getList()
            },
            handleCurrentChange(val) {
                this.listQuery.page = val
                this.getList()
            },
            handleModifyStatus(row, status) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                })
                row.status = status
            },
            beforeFormShow(row) {
                this.resetTemp(row) // 更新数据
                // 存在图片
                this.initQiniu()

                // 存在图片字段转换图片地址显示
                this.initImgUrl()
            },
            afterFormShow(row) {

            },
            beforeFormCommit() {
                this.initImgName()// 图片转换
            },
            resetTemp(row) {

                this.temp = {
                    comment: {}
                }
                if (row) {
                    this.temp = Object.assign({}, row) // copy obj
                }

            },
            handleCreate() {
                this.beforeFormShow()
                this.dialogStatus = 'create'
                this.dialogFormVisible = true
                this.$nextTick(() => {
                    this.afterFormShow()
                    this.$refs['dataForm'].clearValidate()
                })
            },
            handleDelete(scope) {
                this.index = scope.$index
                // this.beforeFormShow(scope.row)
                // this.temp = Object.assign({}, row) // copy obj
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // this.$message({
                    //   type: 'success',
                    //   message: '删除成功!'
                    // })
                    this.deleteData()
                }).catch(() => {
                    this.$message({
                        type: 'error',
                        message: '删除失败'
                    })
                })
            },
            // 显示将图片名封装成可以展示状态集合
            initImgUrl() {
                this.imgList = strsToList(this.temp.comment.img, domain)
            },
            // 关闭显示窗口 重置图片地址 防止错乱
            resetImgUrl() {
                this.avatarList = []
                this.imgList = []
            },
            // 上传或者更新的时候从图片链接中获取图片名字
            initImgName() {
                this.temp.comment.img = listToStrs(this.imgList)
            },
            createData() {
                this.$refs['dataForm'].validate((valid) => {
                        if (valid) {
                            this.beforeFormCommit()

                            save(this.temp).then(res => {
                                this.temp = res.data
                                this.list.unshift(this.temp)
                                this.closeDialogForm()
                                this.$notify({
                                    title: '成功',
                                    message: '创建成功',
                                    type: 'success',
                                    duration: 2000
                                })
                            })
                        }
                    }
                )
            },
            deleteData() {
                // const ids = [this.temp.comment.id]
                const ids = [this.list[this.index].comment.id]
                remove({ids: ids}).then(res => {
                    // 从当前队列中移除
                    this.list.splice(this.index, 1)
                    this.$notify({
                        title: '成功',
                        message: '删除成功',
                        type: 'success',
                        duration: 2000
                    })
                })
            },
            handleUpdate(scope) {
                this.beforeFormShow(scope.row)
                info(scope.row.comment.id).then(res => {
                    this.temp = res.data
                    this.dialogStatus = 'update'
                    this.dialogFormVisible = true
                    this.$nextTick(() => {
                        this.$refs['dataForm'].clearValidate()
                    })
                })
            },
            updateData() {
                this.$refs['dataForm'].validate((valid) => {
                        if (valid) {
                            this.beforeFormCommit()
                            update(this.temp).then(() => {
                                // this.list.splice(this.index, 1, this.temp)
                                this.getList()
                                this.closeDialogForm()
                                this.$notify({
                                    title: '成功',
                                    message: '更新成功',
                                    type: 'success',
                                    duration: 2000
                                })
                            })
                        }
                    }
                )
            },
            closeDialogForm() {
                // 存在图片
                this.resetImgUrl()
                this.dialogFormVisible = false
            },
            // formatJson(filterVal, jsonData) {
            //     return jsonData.map(v => filterVal.map(j => {
            //         return v[j]
            //     }
            // ))
            // },
            // 存在图片
            handleUpload(file) {
                this.qData.key = new Date().valueOf() + file.name
            },
            initQiniu() {
                // 获取七牛配置
                getToken().then(res => {
                    this.qData.token = res.data
                }).catch(error => {
                    console.log(error)
                })
            },
            handleImgUploadSuccess(imgList, file) {
                imgList.push({name: file.response.key, url: domain + file.response.key})
            },
            handleImgRemove(imgList, file) {
                for (var fn of imgList) {
                    if (fn.name === file.name) {
                        imgList.splice(imgList.indexOf(fn), 1)
                    }
                }
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url
                this.dialogVisible = true
            }
        }
    }
</script>
